module.exports = __webpack_public_path__ + "img/zlp.83b69973.png";